import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare let $: any

interface MenuItem {
  id: number;
  title: string;
  imageUrl: string;
  routerLink?: string;
}

@Component({
  selector: 'app-fleetdiag-dashboard-pro',
  templateUrl: './fleetdiag-dashboard-pro.component.html',
  styleUrls: ['./fleetdiag-dashboard-pro.component.scss'],
})
export class FleetdiagDashboardProComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  menuItems: MenuItem[] = [
    {
      id: 1,
      title: 'پارامترهای زنده',
      routerLink: 'live-data',
      imageUrl: '../../../assets/Img/fleetdiag/پارامترهای زنده خودرو.png',
    },
    {
      id: 2,
      title: 'وضعیت مانیتورهای OBD',
      routerLink: 'obd-status',
      imageUrl: '../../../assets/Img/fleetdiag/وضعیت مانیتورهای OBD.png',
    },
    {
      id: 3,
      title: 'خطاهای ECU',
      routerLink: 'ecu-status',
      imageUrl: '../../../assets/Img/fleetdiag/خطاهای ECU.png',
    },
    {
      id: 4,
      title: 'کیفیت رانندگی',
      routerLink: 'driving-quality',
      imageUrl: '../../../assets/Img/fleetdiag/کیفیت رانندگی.png',
    },
    {
      id: 5,
      title: 'شاخص‌ها',
      routerLink: 'indicators',
      imageUrl: '../../../assets/Img/fleetdiag/شاخص‌ها.png',
    },
    // {
    //   id: 3,
    //   title: 'شاخص آلایندگی',
    //   routerLink: 'health-report',
    //   imageUrl: '../../../assets/Img/fleetdiag/شاخص آلایندگی.png',
    // },
    // {
    //   id: 4,
    //   title: 'نمودار  شاخص آلایندگی خودرو',
    //   routerLink: 'indicators/pollution-index-chart',
    //   imageUrl: '../../../assets/Img/fleetdiag/نمودار  شاخص آلایندگی خودرو.png',
    // },
    // {
    //   id: 5,
    //   title: 'شاخص سلامت موتور',
    //   routerLink: 'indicators/engine-health-index',
    //   imageUrl: '../../../assets/Img/fleetdiag/شاخص سلامت موتور.png',
    // },
    // {
    //   id: 6,
    //   title: 'کیفیت احتراق',
    //   routerLink: 'indicators/combustion-quality',
    //   imageUrl: '../../../assets/Img/fleetdiag/کیفیت احتراق.png',
    // },
    // {
    //   id: 7,
    //   title: 'راندمان سوخت',
    //   routerLink: 'indicators/fuel-efficienc',
    //   imageUrl: '../../../assets/Img/fleetdiag/راندمان سوخت.png',
    // },
    // {
    //   id: 7,
    //   title: 'سلامت سیستم هوا',
    //   routerLink: 'indicators/air-intake-health',
    //   imageUrl: '../../../assets/Img/fleetdiag/سلامت سیستم هوا.png',
    // },
    // {
    //   id: 8,
    //   title: 'سلامت سیستم برق',
    //   routerLink: 'indicators/electrical-system-health',
    //   imageUrl: '../../../assets/Img/fleetdiag/سلامت سیستم برق.png',
    // },
    // {
    //   id: 8,
    //   title: 'ریسک خرابی',
    //   routerLink: 'indicators/failure-risk',
    //   imageUrl: '../../../assets/Img/fleetdiag/ریسک خرابی.png',
    // },
  ];

  goBack() {
    const id = this.route.snapshot.paramMap.get('id');
    this.router.navigate(['/carInfo', id]);
  }


}

